import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

const KEY = "lara_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]); // { product, variant, quantity }
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { setItems(JSON.parse(localStorage.getItem(KEY) || "[]")); } catch { setItems([]); }
  }, []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, variant = null, quantity = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product.id === product.id && (i.variant || null) === (variant || null));
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [...prev, { product, variant, quantity }];
    });
    setOpen(true);
  };

  const update = (idx, quantity) => {
    setItems((prev) => prev.map((it, i) => (i === idx ? { ...it, quantity: Math.max(1, quantity) } : it)));
  };

  const remove = (idx) => setItems((prev) => prev.filter((_, i) => i !== idx));
  const clear = () => setItems([]);

  const subtotal = useMemo(() =>
    items.reduce((acc, it) => acc + ((it.product.promo_price || it.product.price) * it.quantity), 0),
  [items]);

  const count = items.reduce((a, i) => a + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
